export const TEST_ID = 'createAssetForm';
